import React, { useMemo, useState } from "react";

import NoImage from "../../assets/image_not_supported.svg";

import { Link, useNavigate, useSearchParams } from "react-router-dom";

import CurrencyConvertor from "../global/currency-convertor";

import ReviewScore from "../global/review-score";

import EntirePropertySell from "../entire-property-info-with-hover";
import NewToHippo from "../global/new-to-hippo";
import { loadPages } from "../../core/lazy-loading";

import LikeProperty from "../global/like-property";
import StarRating from "../global/star-rating/StarRating";

import "./property-card.css";
import { replaceImageUrlSize } from "../../utils/image";

import OfferOfTheDay from "../../assets/Offer.png";
import OfferOfTheDayMobile from "../../assets/offer-of-the-day-sm.png";
import HippoOffer from "./hippo-offer";
import PropertyCardToolTip from "./property-card-tooltip/property-card-tooltip";
import UserInputViewer from "../global/UserInputViewer";
import GlobalImage from "../global/image/image";
import formatFlexibleCancellationPolicy from "../../utils/formatting/format-flexible-cancellation-policy.util";
import toggleClass from "../../utils/dom/toggle-class.util";
import GlobalReviewScoreSm from "../global/review";
import AiReviewScore from "../global/ai-review";
import Tippy from "@tippyjs/react";
import AiReviewToolTip from "../global/ai-review-tooltip";

const INITIAL_AVAILABLE_ROOM_TO_SHOW = 1;

const PropertyCard = ({ idx, property = {}, params }) => {
  const [searchParams] = useSearchParams();

  const [isExpanded, setIsExpanded] = useState(false);

  const navigate = useNavigate();

  const checkinDate = searchParams.get("checkin");
  const checkoutDate = searchParams.get("checkout");
  const adults = searchParams.get("adults");

  const childs = searchParams.get("children");

  const childAges = searchParams.get("child-ages");

  const rooms = searchParams.get("rooms");

  const paramPropertyId = searchParams.get("property-id");

  const propertyName = property?.name;

  const _childAges = childAges ? `&child-ages=${childAges}` : "";

  const navigateURL = `/property/${property?.id}/${encodeURIComponent(
    propertyName
  )}?checkin=${checkinDate}&checkout=${checkoutDate}&adults=${adults}&children=${childs ?? 0}${_childAges}&rooms=${rooms}`;

  function handleMobileNavigate(e) {
    // return if element with this class is clicked ".property-card-left .like"
    const isLikeClicked = e.target.closest("#like-property");
    const isTitle = e.target.closest(".view-details");
    const showMoreButton = e.target.closest(".read-more-content-btn");
    const toolTip = e.target.closest(".tooltip-icon");

    if (isLikeClicked || isTitle || showMoreButton || toolTip) {
      return;
    }

    if (window.innerWidth < 768) {
      navigate(navigateURL);
    }
  }

  const roomSuggesstionLength = property?.availableRooms?.length;

  const basePrice = property?.basePrice;
  const finalPrice = property?.finalPrice;

  const numberOfNights = getNumberOfNights(checkinDate, checkoutDate);

  const overallScore = property?.reviewSummary.overallScore;
  const reviewerCount = property?.reviewSummary.reviewerCount;

  const aiOverallScore = property?.aiReviewSummary?.overallScore;
  const showAiReviews = aiOverallScore > 0;

  const isNew = property?.isNewProperty;

  const showReviews = overallScore > 0 && reviewerCount > 0;

  const showNewTag = isNew && !showReviews;
  const showOfferTag = property?.hasPropertyOffers;

  const TotalTaxRate = property?.totalTaxRate ?? 0;
  const tax = TotalTaxRate * finalPrice;

  const hippoOfferRate = property.hippoOfferRate ? Number((property.hippoOfferRate * 100).toFixed(2)) : 0;

  let discountType = hippoOfferRate > 0 ? "hippoOffer" : "";

  const displayedAvailableRoom = useMemo(() => {
    const availableRoomsToShow = isExpanded ? property?.availableRooms.length : INITIAL_AVAILABLE_ROOM_TO_SHOW;
    return property?.availableRooms.slice(0, availableRoomsToShow);
  }, [property?.availableRooms, isExpanded]);

  const handleExpandClick = () => {
    setIsExpanded((oldExpand) => !oldExpand);
  };

  const shouldShowReadMoreBtn = property?.availableRooms.length > INITIAL_AVAILABLE_ROOM_TO_SHOW;
  const btnText = isExpanded ? "Show less" : "Show all rooms";

  function getScoreName(score) {
    if (score >= 9.6 && score <= 10) return "Outstanding";
    if (score >= 8.6 && score <= 9.5) return "Superb";
    if (score >= 7.6 && score <= 8.5) return "Very Good";
    if (score >= 6.6 && score <= 7.5) return "Good";
    if (score >= 5.6 && score <= 6.5) return "Pleasant";
    if (score >= 4.6 && score <= 5.5) return "Flexible";
    if (score >= 3.6 && score <= 4.5) return "Disappointing";
    if (score >= 2.6 && score <= 3.5) return "Poor";
    if (score >= 1.6 && score <= 2.5) return "Very poor";
    return "Bad";
  }

  return (
    <div className={`property-card box-border${paramPropertyId === property.id ? " exact-property-match" : ""}`} key={idx} onClick={handleMobileNavigate}>
      <div
        style={{
          marginBottom: !showAiReviews && window.innerWidth < 768 && "10px",
        }}
        className="property-image"
      >
        {property?.defaultImage ? (
          <picture>
            <source
              media="(max-width: 768px)"
              srcSet={replaceImageUrlSize(property?.defaultImage, "medium")}
              alt="Building"
              className="building skeleton-loading"
            />
            <GlobalImage
              src={replaceImageUrlSize(property?.defaultImage, "square")}
              alt="Building"
              className="building "
              loading="lazy"
              style={{
                borderRadius: !showAiReviews && window.innerWidth < 768 && "5px",
              }}
            />
          </picture>
        ) : (
          <img
            src={NoImage}
            alt="Not Available"
            className="building"
            onLoad={(e) => {
              toggleClass(e.target, "skeleton-loading", false);
            }}
          />
        )}

        <LikeProperty propertyId={property?.id} isLiked={property.isLiked} />

        {showOfferTag && (
          <picture>
            <source media="(max-width: 767px)" srcSet={OfferOfTheDayMobile} alt="Offer of the day" />
            <GlobalImage className="offer-day-tag" src={OfferOfTheDay} alt="Offer of the day" />
          </picture>
        )}
      </div>
      {showAiReviews && (
        <div className="property-card-mobile__ai-review">
          <div className="average-ai-rating-info ">
            <span className="property-card__ai-review-label">Average AI Rating</span>
            <AiReviewToolTip />
          </div>
          <div className="property-card-mobile__ai-review-wrapper">
            <span className="property-card__ai-review-score">{Math.floor(aiOverallScore * 10) / 10}</span>
            <span className="property-card__ai-review-desc">{getScoreName((Math.floor(aiOverallScore * 10) / 10) * 2)}</span>
          </div>
        </div>
      )}
      <div className="property-card-info">
        <div className="property-info">
          <div className="prop-data">
            <h3>
              <UserInputViewer tag="Link" to={navigateURL} className="view-details" text={propertyName} />
            </h3>
            <UserInputViewer tag="address" text={property?.fullAddress} />

            <StarRating rating={property?.rating} />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              alignItems: "flex-end",
            }}
          >
            {/* {showReviews && <ReviewScore score={overallScore} totalReviews={reviewerCount} />} */}
            {showAiReviews && (
              <div className="property-card__ai-review">
                <div className="property-card__ai-review-wrapper">
                  <div className="average-ai-rating-info">
                    <span className="property-card__ai-review-label">Average AI Rating</span>
                    <AiReviewToolTip />
                  </div>
                  <span className="property-card__ai-review-desc">{getScoreName((Math.floor(aiOverallScore * 10) / 10) * 2)}</span>
                </div>
                <span className="property-card__ai-review-score">{Math.floor(aiOverallScore * 10) / 10}</span>
              </div>
            )}

            {showNewTag && <NewToHippo />}

            {hippoOfferRate > 0 && <HippoOffer hippoOfferRate={hippoOfferRate} />}

            {/* <SustainabilityScore /> */}
          </div>
        </div>

        <div className="available-rooms">
          <div className="suggested-rooms">
            {displayedAvailableRoom.map((room, i) => (
              <PropListingSingleRoom
                key={room.room_id}
                room={room}
                isSingle={roomSuggesstionLength === 1}
                isLast={roomSuggesstionLength === i + 1}
                propertyType={property.type}
                propertySellType={property.sellType}
              />
            ))}
            {shouldShowReadMoreBtn && (
              <button onClick={handleExpandClick} className="read-more-content-btn" aria-expanded={isExpanded}>
                {btnText}
              </button>
            )}

            {!property.isPayAtProperty ? (
              <div className="credit-card-info">Credit Card required</div>
            ) : (
              <div
                style={{
                  color: "#008234",
                }}
                className="credit-card-info"
              >
                Credit Card not required
              </div>
            )}
          </div>

          <div className="pricing-info">
            <div className="price-wrapper">
              <span className="count-nac">
                {numberOfNights} {numberOfNights > 1 ? "nights" : "night"}, &nbsp;
                {params.guests.adultCount} {params.guests.adultCount > 1 ? "adults" : "adult"}
                {params.guests.childCount > 0 && (
                  <>
                    ,&nbsp;{params.guests.childCount} {params.guests.childCount > 1 ? "children" : "child"}
                  </>
                )}
                {/* children */}
              </span>

              <div className="price">
                {/* <span className="cut-price">USD {property.base_price}</span> */}
                {basePrice !== finalPrice && <CurrencyConvertor className="cut-price" price={basePrice} />}

                <CurrencyConvertor className="original-price" primaryDiscountType={discountType} price={finalPrice} />
              </div>

              {TotalTaxRate > 0 && (
                <div className="include-tax">
                  +<CurrencyConvertor price={tax} />
                  &nbsp; taxes and charges
                </div>
              )}
            </div>

            <Link
              to={navigateURL}
              // target="_blank"
              // className="btn see-more"
              className="global-button global-button--primary listing-card-button"
              onMouseOver={() => {
                loadPages.singleProperty();
              }}
            >
              See available rooms
            </Link>
          </div>
        </div>
        <div className="property-card-sm-wrapper">
          {/* {showAiReviews && <GlobalReviewScoreSm score={aiOverallScore} totalReviews={aiReviewerCount} isRtl={false} />} */}
          {/* {showReviews && <ReviewScore score={overallScore} totalReviews={reviewerCount} isRtl={false} />} */}

          {showNewTag && <NewToHippo />}
          <div className="price-wrapper">
            <span className="count-nac">
              ({numberOfNights} {numberOfNights > 1 ? "nights" : "night"}, &nbsp;
              {params.guests.adultCount} {params.guests.adultCount > 1 ? "adults" : "adult"}
              {params.guests.childCount > 0 && (
                <>
                  ,&nbsp;{params.guests.childCount} {params.guests.childCount > 1 ? "children" : "child"}
                </>
              )}
              )
            </span>

            <div className="price">
              {/* <span className="cut-price">USD {property.base_price}</span> */}
              {basePrice !== finalPrice && <CurrencyConvertor className="cut-price" price={basePrice} />}

              <CurrencyConvertor className="original-price" primaryDiscountType={discountType} price={finalPrice} />
            </div>

            {TotalTaxRate > 0 && (
              <div className="include-tax">
                +<CurrencyConvertor price={tax} />
                &nbsp; taxes and charges
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyCard;

function PropListingSingleRoom({
  room,
  isLast = false,
  isSingle = false,

  propertyType,
  propertySellType,
}) {
  const availableUnits = room.maxAvailability;

  const rateplan = room.rateplan;
  const selectedUnits = rateplan.selectedUnits;
  const cancellationPolicy = rateplan.cancellationPolicy;

  const flexibleWording = formatFlexibleCancellationPolicy(cancellationPolicy);

  return (
    <div
      className="prop-listing-single-room"
      style={{
        paddingBottom: isLast ? "0" : "8px",
        paddingLeft: "29px",
      }}
      data-count={`x${selectedUnits}`}
    >
      <div className="room-name-wrapper">
        <h4 className="room-name">{room.name}</h4>
        <h5 className="guest-count">
          ( {rateplan.adultCount}
          {rateplan.adultCount > 1 ? " adults " : " adult "}
          {rateplan.childCount > 0 && (
            <>
              and {rateplan.childCount} {rateplan.childCount > 1 ? "children" : "child"}
            </>
          )}
          )
        </h5>
      </div>
      {propertySellType === "ENTIRE_PROPERTY" && (
        <EntirePropertySell selectedUnits={selectedUnits} propertyType={propertyType} subRooms={room.subRooms ?? []} features={room.features ?? []} />
      )}
      {propertySellType === "PRIVATE_ROOM" && (
        <span>
          <DoubleBed />{" "}
          {room.beds?.map((bed, i) => {
            const bed_type = bed.type.split(" /")[0];

            return (
              <React.Fragment key={i}>
                {i !== 0 && " , "}
                {bed.quantity} {bed_type}
              </React.Fragment>
            );
          })}
        </span>
      )}
      <ul>
        <li>
          <div className={`${availableUnits > 3 ? "text-black" : "text-red"}`}>
            Only {availableUnits} {availableUnits > 1 ? "rooms" : "room"} {availableUnits > 1 ? "are" : "is"} available
          </div>
        </li>
        {flexibleWording && (
          <li>
            <div className="text-green">{flexibleWording}</div>
          </li>
        )}

        <li>
          <div className="rateplan-meal-options">
            {rateplan.mealPlanType}
            <PropertyCardToolTip meals={rateplan.meals} />
          </div>
        </li>
      </ul>
    </div>
  );
}

function DoubleBed() {
  return (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.49991e-05 13.2003V7.55432C-0.00213163 7.19502 0.07468 6.83964 0.225045 6.51332C0.372584 6.1899 0.606066 5.91318 0.900045 5.71332V3.14732C0.892722 2.83636 0.949896 2.52725 1.06796 2.23948C1.18603 1.95172 1.36243 1.69153 1.58604 1.47532C1.809 1.25393 2.07448 1.07999 2.36648 0.963982C2.65848 0.847973 2.97095 0.7923 3.28504 0.800319H7.33504C7.65576 0.798069 7.9722 0.873919 8.25704 1.02132C8.54241 1.16953 8.79507 1.37356 9.00004 1.62132C9.20236 1.37567 9.45067 1.17186 9.73104 1.02132C10.0119 0.872957 10.3254 0.796998 10.643 0.800319H14.693C15.0087 0.792986 15.3226 0.848934 15.6163 0.964864C15.91 1.08079 16.1775 1.25436 16.403 1.47532C16.6301 1.68963 16.8097 1.94915 16.9302 2.23713C17.0508 2.52512 17.1097 2.83518 17.103 3.14732V5.71632C17.397 5.91618 17.6305 6.1929 17.778 6.51632C17.9269 6.84196 18.0027 7.19626 18 7.55432V13.2003H16.65V11.4293H1.35004V13.2003H4.49991e-05ZM9.67505 5.33932H15.75V3.14732C15.7546 3.01119 15.7302 2.87564 15.6785 2.74963C15.6268 2.62362 15.5489 2.51002 15.45 2.41632C15.3495 2.32109 15.2311 2.24663 15.1017 2.19721C14.9724 2.14779 14.8345 2.12438 14.696 2.12832H10.575C10.4515 2.12699 10.3294 2.15429 10.2182 2.20807C10.1069 2.26186 10.0097 2.34066 9.93404 2.43832C9.76485 2.63558 9.67284 2.88745 9.67505 3.14732V5.33932ZM2.25005 5.33932H8.32504V3.14732C8.32725 2.88745 8.23524 2.63558 8.06604 2.43832C7.99039 2.34066 7.89314 2.26186 7.78193 2.20807C7.67072 2.15429 7.54857 2.12699 7.42505 2.12832H3.28504C3.14921 2.12605 3.01434 2.15148 2.88866 2.20306C2.76298 2.25464 2.64912 2.33128 2.55404 2.42832C2.45708 2.52115 2.38037 2.63303 2.32874 2.75694C2.27711 2.88085 2.25168 3.0141 2.25405 3.14832L2.25005 5.33932ZM1.35004 10.1003H16.65V7.55432C16.6528 7.43696 16.6312 7.3203 16.5866 7.2117C16.542 7.1031 16.4755 7.00491 16.391 6.92332C16.307 6.83974 16.2068 6.77405 16.0966 6.73023C15.9865 6.6864 15.8686 6.66534 15.75 6.66832H2.25005C2.13152 6.66534 2.01362 6.6864 1.90345 6.73023C1.79328 6.77405 1.69314 6.83974 1.60905 6.92332C1.52464 7.00491 1.45805 7.1031 1.41348 7.2117C1.3689 7.3203 1.3473 7.43696 1.35004 7.55432V10.1003Z"
        fill="#606060"
      />
    </svg>
  );
}

function getNumberOfNights(checkInDateStr, checkOutDateStr) {
  const oneDayMs = 86400000; // Number of milliseconds in a day
  const checkInDate = new Date(checkInDateStr);
  const checkOutDate = new Date(checkOutDateStr);
  const timeDiffMs = checkOutDate.getTime() - checkInDate.getTime();
  return Math.ceil(timeDiffMs / oneDayMs);
}
const tooltipContent = (
  <div className="ai-tooltip-box">
    <h3>About Ai Summaries</h3>
    <p>
      Lorem ipsum dolor sit amet consectetur. Nisi in sodales at neque. Porttitor turpis arcu at scelerisque eu metus viverra. Diam aliquam enim eu
      elementum ut. Blandit vestibulum felis eu quis diam tellus.
    </p>
  </div>
);
